module.exports = __webpack_public_path__ + "static/media/picking-queue.c1bb2ebf.svg";